<template>
  <div
    @mouseover="toggleMenu(true)"
    @mouseleave="toggleMenu(false)"
    class="main_navigation"
    :class="mainMenuClass"
  >
    <router-link class="item" to="/" exact>
      <img :src="$icons.home" width="32" alt="home"/>
      <div v-bind:style="mainMenuText" class="main_nav_title">Accueil</div>
    </router-link>

    <router-link v-for="(m, key) in menu" class="item" :to="m.link" :key="key">
      <img :src="$icons[m.icon]" width="32" alt="menu"/>
      <div v-bind:style="mainMenuText" class="main_nav_title">
        {{ m.name }}
      </div>
    </router-link>

    <router-link class="item ml" to="/ml">
      <img :src="$icons.book" width="32" alt="book" />
      <div v-bind:style="mainMenuText" class="main_nav_title" style="margin-left: 6px;">
        Mentions légales
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "MainMenu",
  data: function () {
    return {
      menu: [
        // {
        //   name: 'Acceuil',
        //   icon: 'home',
        //   link: '/'
        // },
        {
          name: "Portefeuille",
          icon: "case",
          link: "/portefeuille",
        },
        {
          name: "Recherche",
          icon: "user",
          link: "/search",
        },
        {
          name: "Extraction",
          icon: "save",
          link: "/extraction/assure",
        },
        {
          name: "Documents",
          icon: "docs",
          link: "/documents",
        },
        // {
        //   name: 'Graphique',
        //   icon: 'chart pie',
        //   link: '/graphique'
        // },

        // {
        //   name: 'Actualités',
        //   icon: 'newspaper',
        //   link: '/actualites'
        // },
        {
          name: "Contact",
          icon: "email",
          link: "/contact",
        },
      ],
      mainMenuClass: {
        opened_menu: false,
      },
      mainMenuText: {
        display: "none",
        fontSize: "1px",
      },
    };
  },
  methods: {
    toggleMenu(open) {
      if (open && this.mainMenuClass.opened_menu === false) {
        this.mainMenuClass.opened_menu = true;
        this.mainMenuText.display = "inline-block";
        setTimeout(() => {
          this.mainMenuText.fontSize = "16px";
        }, 100);
      }

      if (!open) {
        this.mainMenuClass.opened_menu = false;
        this.mainMenuText.display = "none";
        this.mainMenuText.fontSize = "1px";
      }
    },
  },
};
</script>

<style scoped>
.opened_menu {
  width: 200px !important;
  transition: all 0.1s ease;
}
.main_navigation {
  position: fixed;
  background-color: #2b3e50;
  top: 60px;
  bottom: 0;
  text-align: left;
  width: 60px;
  padding-top: 4px;
  transition: all 0.3s ease;
  z-index: 10;
}
.main_navigation .item {
  background-color: #2b3e50;
  padding: 14px 0 0 11px;
  cursor: pointer;
  display: block;
  height: 56px;
  border-bottom: 1px solid #3a4e62;
}
.item.ml {
  position: absolute;
  bottom: 0px;
  border-top: 1px solid rgb(58, 78, 98);
  width: 100%;
}
.main_navigation .router-link-exact-active i {
  color: orange;
}
.main_navigation .router-link-active i {
  color: orange;
}
.main_navigation .item:hover {
  background-color: #3a4e62;
  color: #fff;
}
.main_nav_title {
  color: white;
  margin: 0 0 0 20px;
  display: none;
  transition: 0.3s;
}
</style>
